import { Alert, Button, LoadingSpinner, ModalDialog } from 'vetrf-ui';
import { EaeuInfo, EaeuInfoParams } from 'api/eaeu/types';
import { GmpDto } from 'modules/gmp/gmpRegistry/api/params';
import styles from '../ResultTransactionsModal/ResultTransactionsModal.module.scss';

type SubmitTransactionsModalProps = {
  onClose: () => void;
  onSubmit: () => void;
  transactions: EaeuInfoParams[] | EaeuInfo[] | null;
  sending: boolean;
  gmpData?: GmpDto;
};

export const SubmitTransactionsModal = ({
  onClose,
  onSubmit,
  transactions,
  gmpData,
  sending,
}: SubmitTransactionsModalProps) => (
  <ModalDialog
    header="Подтверждение"
    headerClass="modal-header modal-large no-close-btn"
    bodyClass="modal-body scrollable"
    footer={
      <>
        <Button
          color="success"
          icon="arrow-up"
          iconColor="white"
          iconSize={100}
          size="sm"
          disabled={sending}
          text="Отправить"
          onClick={onSubmit}
        />
        <Button
          color="grey"
          icon="times"
          iconColor="white"
          iconSize={100}
          onClick={onClose}
          size="sm"
          disabled={sending}
          text="Закрыть"
        />
      </>
    }
  >
    <div className={styles.bodyText}>
      Вы уверены, что хотите выполнить передачу в ИИС ЕАЭС транзакций:
    </div>
    <ul className="item-list">
      {transactions?.map(({ gmpForSending, transactionInfo, transactionType }) => (
        <li key={transactionType?.id} className="item-default bigger-120">
          {transactionType?.name || transactionInfo?.transactionType.name}
          <br />
          <small className="text-muted">
            {transactionInfo ? (
              <ul className="pl-10">
                {gmpForSending?.map((el) => (
                  <li key={el.id}>{`${el.registrationNumber} - ${el.status.name}`}</li>
                ))}
              </ul>
            ) : (
              <>{!!gmpData && `(${gmpData.registrationNumber} - ${gmpData.status.name})`}</>
            )}
          </small>
        </li>
      ))}
    </ul>

    {sending && (
      <Alert messageType="info" className="mt-10">
        <LoadingSpinner icon="spinner" spin="spin" text="Отправка" />
      </Alert>
    )}
  </ModalDialog>
);
